import { useCallback } from 'react';
import { useDispatch } from 'src/store';
import { actions } from 'src/store/navbar';
import { useBackButtonActions } from './useBackButton';
import { useCuisineFilterButtonActions } from './useCuisineFilterButton';
import { useCuisineFiltersActions } from './useCuisineFilters';
import { useDatePickerActions } from './useDatePicker';
import { useDietaryFiltersActions } from './useDietaryFilters';
import { useFilterBarActions } from './useFilterBar';
import { useInlineFilterButtonsActions } from './useInlineFilterButtons';
import { useMenuBarActions } from './useMenuBar';
import { useMoreFiltersActions } from './useMoreFilters';
import { useNavigationActions } from './useNavigation';
import { usePromoActions } from './usePromo';
import { useProteinFiltersActions } from './useProteinFilters';
import { useSearchActions } from './useSearch';
import { useSubCuisineFiltersActions } from './useSubCuisineFilters';

export const useNavbarActions = () => {
  const dispatch = useDispatch();
  const setIsScrollingUp = useCallback(
    (isScrollingUp: boolean) => {
      dispatch(actions.setIsScrollingUp({ isScrollingUp }));
    },
    [dispatch]
  );
  const resetState = useCallback(
    ({ hideBackButton }: { hideBackButton: boolean }) => {
      dispatch(actions.resetState({ hideBackButton }));
    },
    [dispatch]
  );

  return {
    animations: {
      show: () => {
        dispatch(actions.showAnimations());
      },
      hide: () => {
        dispatch(actions.hideAnimations());
      },
    },
    backButton: useBackButtonActions(),
    cuisineFilters: useCuisineFiltersActions(),
    cuisineFilterButton: useCuisineFilterButtonActions(),
    datePicker: useDatePickerActions(),
    dietaryFilters: useDietaryFiltersActions(),
    filterBar: useFilterBarActions(),
    inlineFilterButtons: useInlineFilterButtonsActions(),
    menuBar: useMenuBarActions(),
    moreFilters: useMoreFiltersActions(),
    navigation: useNavigationActions(),
    promo: usePromoActions(),
    proteinFilters: useProteinFiltersActions(),
    search: useSearchActions(),
    setIsScrollingUp,
    subCuisineFilters: useSubCuisineFiltersActions(),
    resetState,
  };
};
